import 'swiper/css';

import { useMemo } from 'react';
import filter from 'lodash/filter';
import Image from 'next/future/image';
import { useRouter } from 'next/router';
import { useTranslation } from 'react-i18next';
import { Swiper, SwiperSlide } from 'swiper/react';

import LinkTo from '../LinkTo';

const StaticPagesCards = () => {
  const router = useRouter();
  const { t } = useTranslation();

  const cards = useMemo(
    () =>
      filter(
        [
          {
            title: t('P_ABOUT.CARDS.CARD-1.TITLE'),
            description: t('P_ABOUT.CARDS.CARD-1.DESC'),
            src: '/v2/static-pages/uynners.jpg',
            href: '/uynners'
          },
          {
            title: t('P_ABOUT.CARDS.CARD-2.TITLE'),
            description: t('P_ABOUT.CARDS.CARD-2.DESC'),
            src: '/v2/static-pages/about.jpg',
            href: '/about'
          },
          {
            title: t('P_ABOUT.CARDS.CARD-3.TITLE'),
            description: t('P_ABOUT.CARDS.CARD-3.DESC'),
            src: '/v2/static-pages/areas.jpg',
            href: '/areas'
          },
          {
            title: t('P_ABOUT.CARDS.CARD-4.TITLE'),
            description: t('P_ABOUT.CARDS.CARD-4.DESC'),
            src: '/v2/static-pages/sustainability.jpg',
            href: '/sustainability'
          },
          {
            title: t('P_ABOUT.CARDS.CARD-5.TITLE'),
            description: t('P_ABOUT.CARDS.CARD-5.DESC'),
            src: '/v2/static-pages/manufacturing.jpg',
            href: '/manufacturing'
          }
        ],
        ({ href }) => !router.pathname.includes(href)
      ),
    [router.pathname]
  );

  return (
    <div className="section full">
      <div className="section-wrapper">
        <Swiper
          wrapperTag="ul"
          slidesPerView={1.2}
          spaceBetween={16}
          breakpoints={{
            768: {
              slidesPerView: 2.2
            },
            1024: {
              slidesPerView: 4
            }
          }}
        >
          {cards.map((card, idx) => (
            <SwiperSlide
              key={idx}
              tag="li"
              className="relative rounded-uyn overflow-hidden"
            >
              <div className="absolute inset-0 bg-black/20" />

              <Image
                src={card.src}
                alt={card.title}
                width={0}
                height={0}
                sizes="100vw"
                className="min-h-[300px] w-full h-auto object-contain"
              />

              <LinkTo
                href={card.href}
                aria-label={card.title}
                className="absolute inset-0 flex flex-col justify-center items-center text-white p-6 md:p-8 hover:bg-black/20"
              >
                <h3 className="h4">{card.title}</h3>

                <p className="text-body text-center">{card.description}</p>
              </LinkTo>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
};

export default StaticPagesCards;
